import React, { useState } from 'react';
import BtnFilled from '../../components/BtnFilled';
import BtnOutlined from '../../components/BtnOutlined';
import ConfirmAlert from '../../components/ConfirmAlert';
import { useFirmwarePoliciesStore } from './state/use-firmware-policies-store';
import AlertAccent from '../../components/AlertAccent';

const ControlPanel = () => {
  const { updateAllDevices } = useFirmwarePoliciesStore();
  const [pendingAllowUpdates, setPendingAllowUpdates] = useState(null);

  const closeAlert = () => setPendingAllowUpdates(null);

  const handleConfirm = async () => {
    if (pendingAllowUpdates === null) return;

    await updateAllDevices(pendingAllowUpdates);
    closeAlert();
  };

  return (
    <>
      <div className="max-w-7xl mx-auto bg-white shadow-md rounded-3xl p-4 mt-6">
        <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <h3 className="text-base sm:text-lg font-medium text-gray-700">Массовое управление обновлениями</h3>
            <p className="text-sm text-gray-500 mt-1">Установите единое значение разрешения на обновление для всех устройств в системе</p>
          </div>
          <div className="flex gap-3 sm:min-w-[360px]">
            <BtnOutlined title="Запретить всем" btnCb={() => setPendingAllowUpdates(false)} />
            <BtnFilled title="Разрешить всем" btnCb={() => setPendingAllowUpdates(true)} />
          </div>
        </div>
      </div>

      <ConfirmAlert
        showAlert={pendingAllowUpdates !== null}
        delCb={handleConfirm}
        confirmLabel={pendingAllowUpdates ? 'Разрешить' : 'Запретить'}
        setShowAlert={(open) => !open && closeAlert()}
        title={'Управление обновлением для всех устройств'}>
        <AlertAccent text={pendingAllowUpdates ? 'Разрешить обновления для всех устройств?' : 'Запретить обновления для всех устройств?'} showAlert={true} />
      </ConfirmAlert>
    </>
  );
};

export default ControlPanel;
